const PropertyFormMaterialsTab = ({ children }) => {
    return <>{children}</>
}

export default PropertyFormMaterialsTab